import { render, staticRenderFns } from "./AuthorisationCallback.vue?vue&type=template&id=a5fa316e&"
import script from "./AuthorisationCallback.vue?vue&type=script&lang=js&"
export * from "./AuthorisationCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports